"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.qc = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const client_1 = require("react-dom/client");
const react_query_1 = require("@tanstack/react-query");
const react_router_dom_1 = require("react-router-dom");
const App_1 = __importDefault(require("./components/App"));
const Login_1 = __importDefault(require("./components/Login"));
const ApplicationContext_1 = __importDefault(require("./context/ApplicationContext"));
require("./styles/main.scss");
exports.qc = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            retry: false,
            staleTime: 1000 * 60 * 10, // 10 minutes
        },
    },
});
const AppRoot = ((0, jsx_runtime_1.jsx)(react_1.StrictMode, { children: (0, jsx_runtime_1.jsx)(ApplicationContext_1.default, { children: (0, jsx_runtime_1.jsx)(react_query_1.QueryClientProvider, Object.assign({ client: exports.qc }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { children: (0, jsx_runtime_1.jsxs)(react_router_dom_1.Routes, { children: [(0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '/login', element: (0, jsx_runtime_1.jsx)(Login_1.default, {}) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Route, { path: '/*', element: (0, jsx_runtime_1.jsx)(App_1.default, {}) })] }) }) })) }) }));
const domRoot = document.getElementById('zenith-ui-root');
const root = (0, client_1.createRoot)(domRoot);
root.render(AppRoot);
